import 'ts-polyfill'

import Vue from 'vue'
import BookmarksApp from './BookmarksApp'
import BookmarkButton from './components/bookmarkButton'
import Purchase from './components/purchase'
import Login from 'heise-login'
import { trackingReload } from 'heise-tracking-reload'
import $ from 'jquery'

import HeiseVideo from 'heise-video'

import './utils/extras'

console.log('Select built at: ' + BUILT_AT, COMMIT_SHA)

// export for others scripts to use
window.$ = window.jQuery = $

Vue.config.devtools = process.env.NODE_ENV !== 'production'

$(document).ready(function () {
  require('./plugins/photoswipe')

  const videoArr = document.getElementsByClassName('videoplayerjw')
  Array.prototype.forEach.call(videoArr, function (element) {
    element.video = new HeiseVideo(element)
  })

  function setLoginNavigation(loggedIn) {
    if (loggedIn) {
      $('[data-show=logged-in]').show()
      $('[data-show=logged-out]').hide()
      $('#bookmarkbutton').removeClass('is-disabled')
    } else {
      $('[data-show=logged-in]').hide()
      $('[data-show=logged-out]').show()
      $('#bookmarkbutton').addClass('is-disabled')
    }
  }
  const login = new Login()
  setLoginNavigation(login.isLoggedIn())

  login.on('login', function () {
    setLoginNavigation(login.isLoggedIn())
  })

  /* eslint-disable no-new */
  if (document.getElementById('bookmarksApp')) {
    new Vue({
      el: '#bookmarksApp',
      template: '<BookmarksApp/>',
      components: { BookmarksApp },
    })
  }
  /* eslint-enable no-new */

  // templateArticleData is created via perl inside
  // templates/includes/article_data.html.ep!
  // This is by now the only possible way to get those infos into vue...
  const data = (typeof (window.articleData) === 'undefined') ? undefined : window.articleData

  /* eslint-disable no-new */
  if (document.getElementById('bookmarkButton')) {
    new Vue({
      el: '#bookmarkButton',
      template: '<bookmark-button :article-data="articleData"></bookmark-button>',
      components: { BookmarkButton },
      data: {
        articleData: data
      }
    })
  }
  /* eslint-enable no-new */

  /* eslint-disable no-new */
  if (document.getElementById('purchase')) {
    new Vue({
      el: '#purchase',
      template: '<purchase :article-data="articleData"></purchase>',
      components: { Purchase },
      data: {
        articleData: data
      }
    })
  }
  /* eslint-enable no-new */

  // Navbar dropdowns
  $('.nav__link--dropdown').click(function (e) {
    // click to close?
    if ($(this).hasClass('active')) {
      $(this).siblings('.nav__list').hide()
      $('.topbar').removeClass('topbar--has-open-dropdown')
    } else {
      $('.nav__list .nav__list').hide()
      $(this).siblings('.nav__list').show()
      $('.nav__link.active').removeClass('active')
      $('.topbar').addClass('topbar--has-open-dropdown')
    };

    $(this).toggleClass('active')

    // Need to be called for iPad
    // if you click an anchor in mobile Safari, the viewport will scroll
    hasScrolled()
    e.stopPropagation()
  })
  //  close al open dropdowns if clicked anywhere
  $('html').click(function () {
    $('.nav__list .nav__list').hide()
    $('.nav__link.active').removeClass('active')
    $('.topbar').removeClass('topbar--has-open-dropdown')
  })

  // Hide Header on on scroll down
  let didScroll
  let lastScrollTop = 0
  const delta = 5
  const navbarHeight = $('.topbar').outerHeight()
  $(window).scroll(function (event) {
    didScroll = true
  })

  function hasScrolled() {
    const st = $('body').scrollTop()
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) { return }

    // If they scrolled down and are past the navbar, add class .topbar-u-p.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down (only if no dropdown is open)
      if (!$('.topbar').hasClass('topbar--has-open-dropdown')) {
        $('.topbar').removeClass('topbar--down').addClass('topbar--up')
      }
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $('.topbar').removeClass('topbar--up').addClass('topbar--down')
      }
    }

    lastScrollTop = st
  }

  setInterval(function () {
    if (didScroll) {
      hasScrolled()
      didScroll = false
    }
  }, 250)

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      // Page came from Firefox's and Safari's "BFCache", and will not fire
      // tracking pixels -> reload those manually
      console.log('Reloading due to pageshow.persisted')
      trackingReload.reloadAll()
    }
  })
  const linkButtons = document.getElementsByClassName(linkButtonClassName)
  const downloadState = {
    aborted: false,
    activeRequest: false,
    response: null,
    elapsedMiliSec: null,
  }
  if (linkButtons && linkButtons[0]) {
    linkButtons[0].addEventListener('click', function (evt) {
      requestDownloadData(downloadState)
        .then(function (response) {
          downloadState.activeRequest = false
          downloadState.elapsedMiliSec = 0
          downloadState.response = JSON.parse(response)

          if (downloadState.response && downloadState.response.downloadUrl) {
            // PDF is cached and ready to download
            window.location.href = downloadState.response.downloadUrl
          } else if (downloadState.response && downloadState.response.waitSec) {
            // PDF will have to be created first

            // Show progress bar
            updateDownloadProgress(downloadState)

            // Activate refresh timer every 100 ms
            timerRefreshProgress = setInterval(function () { refreshProgress(downloadState) }, 100)

            // Activate update timer every 3 seconds
            timerDownloadData = setInterval(function () { updateDownloadData(downloadState) }, 3000)
          } else {
            showDownloadProgressError('Die Vorbereitungen für den Download sind fehlgeschlagen: Fehlercode 11')
          }
        }).catch(function (Error) {
          downloadState.activeRequest = false
          console.log(Error)
          showDownloadProgressError('Die Vorbereitungen für den Download sind fehlgeschlagen: Fehlercode 21')
        })
      // Prevent default link action
      evt.preventDefault()
    })
  }
})

const linkButtonClassName = 'issue-download-link'
const progressClassName = 'issue-download-link-progress'
const loaderClassName = 'issue-download-link-loader'
const containerClassName = 'issue-download-link-progress-container'
const descriptionClassName = 'issue-download-link-progress-description'
const countdownClassName = 'issue-download-link-progress-countdown'

let timerRefreshProgress = null
let timerDownloadData = null

function stopTimers(downloadState) {
  downloadState.aborted = true
  clearInterval(timerDownloadData)
  clearInterval(timerRefreshProgress)
}

/**
 * Liefert die Summe aus der bisherige Wartezeit und der vorraussichtlich
 * verbleibenden Wartezt in Millisekunden
 */
function getElapsedAndEstimatedWait(downloadState) {
  return downloadState.elapsedMiliSec + downloadState.response.waitSec * 1000
}

function refreshProgress(downloadState) {
  downloadState.elapsedMiliSec += 100
  if (downloadState.elapsedMiliSec % 1000 === 0) {
    downloadState.response.waitSec -= 1
  }
  if (downloadState.elapsedMiliSec >= 2 * getElapsedAndEstimatedWait(downloadState)) {
    showDownloadProgressError(
      'Die Vorbereitungen für den Download sind fehlgeschlagen: Fehlercode 30'
    )
    console.log('Timeout after' + downloadState.elapsedMiliSec + 'ms')
    stopTimers(downloadState)
  }
  if (!downloadState.aborted) {
    updateDownloadProgress(downloadState)
  }
}

function updateDownloadData(downloadState) {
  if (downloadState.activeRequest || downloadState.aborted) {
    return
  }
  requestDownloadData(downloadState)
    .then(function (response) {
      downloadState.activeRequest = false
      downloadState.response = JSON.parse(response)
      if (downloadState.response && downloadState.response.downloadUrl) {
        removeProgressAndShowButton()
        stopTimers(downloadState)
        window.location.href = downloadState.response.downloadUrl
      } else if (!downloadState.response || !downloadState.response.waitSec) {
        showDownloadProgressError(
          'Die Vorbereitungen für den Download sind fehlgeschlagen: Fehlercode 10'
        )
        stopTimers(downloadState)
      }
    })
    .catch(function (Error) {
      console.log(Error)
      showDownloadProgressError(
        'Die Vorbereitungen für den Download sind fehlgeschlagen: Fehlercode 20'
      )
      stopTimers(downloadState)
    })
}

function requestDownloadData(downloadState) {
  return new Promise(function (resolve, reject) {
    downloadState.activeRequest = true
    const linkButton = document.getElementsByClassName(linkButtonClassName)[0]
    const url = linkButton.getAttribute('href')
    // eslint-disable-next-line no-undef
    const request = new XMLHttpRequest()
    request.open('GET', url)
    request.setRequestHeader('Accept', 'application/json')
    request.onload = function () {
      if (request.status === 200) {
        resolve(request.response)
      } else {
        reject(Error('Could not load download data; error code:' + request.statusText))
      }
    }
    request.onerror = function (e) {
      reject(Error('There was a network error.' + e))
    }
    request.send()
  })
}

function removeProgress() {
  const progressElement = document.getElementById(progressClassName)
  if (progressElement) {
    progressElement.remove()
  }
}

function removeLoader() {
  const loaderElement = document.getElementById(loaderClassName)
  if (loaderElement) {
    loaderElement.remove()
  }
}

function setDescription(description) {
  const descriptionElement = document.getElementsByClassName(descriptionClassName)[0]
  descriptionElement.innerHTML = description
}

function setCountdown(countdown) {
  const countdownElement = document.getElementsByClassName(countdownClassName)[0]
  countdownElement.innerHTML = countdown
}

function updateDownloadProgress(downloadState) {
  // Hide button while progressing
  const linkButton = document.getElementsByClassName(linkButtonClassName)[0]
  linkButton.classList.add('issue-download-link--hide')

  const container = document.getElementsByClassName(containerClassName)[0]
  if (downloadState.response.waitSec > 0) {
    removeLoader()
    // Create or update progress bar
    let progress = document.getElementById(progressClassName)
    if (progress) {
      progress.setAttribute('value', downloadState.elapsedMiliSec)
      progress.setAttribute('max', getElapsedAndEstimatedWait(downloadState))
    } else {
      progress = document.createElement('progress')
      progress.setAttribute('id', progressClassName)
      progress.setAttribute('value', downloadState.elapsedMiliSec)
      progress.setAttribute('max', getElapsedAndEstimatedWait(downloadState))
      container.appendChild(progress)
      setDescription('Der Download wird vorbereitet!')
    }
    setCountdown('Die voraussichtliche verbleibende Wartezeit beträgt ' + downloadState.response.waitSec + ' Sekunden')
  } else {
    removeProgress()
    // Show dots
    let loader = document.getElementById(loaderClassName)
    if (!loader) {
      // console.log('create loader')
      loader = document.createElement('span')
      loader.setAttribute('id', loaderClassName)
      loader.innerHTML = '<a-loader type="dots" align="left"></a-loader>'
      container.appendChild(loader)
    }
    setCountdown('Der Download startet in den nächsten Sekunden. ')
  }
}

function showDownloadProgressError(message) {
  removeProgress()
  removeLoader()
  // Show error message
  setDescription(message)
  setCountdown('')
}

function removeProgressAndShowButton() {
  removeProgress()
  removeLoader()
  // Remove Description or Error
  setDescription('')
  setCountdown('')
  // Show Button and text again
  const linkButton = document.getElementsByClassName(linkButtonClassName)[0]
  linkButton.classList.remove('issue-download-link--hide')
}
